import { render, staticRenderFns } from "./BuyProductComponent.vue?vue&type=template&id=967b7c28&scoped=true&"
import script from "./BuyProductComponent.vue?vue&type=script&lang=ts&"
export * from "./BuyProductComponent.vue?vue&type=script&lang=ts&"
import style0 from "./BuyProductComponent.vue?vue&type=style&index=0&id=967b7c28&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "967b7c28",
  null
  
)

export default component.exports